import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import { AppDispatch, Store } from 'store';
import getLanguagePrefix from 'store/app/selector/getLanguagePrefix';
import getLocaleSelector from 'store/app/selector/getLocaleSelector';
import { setCategoryLoadingAction } from 'store/category/slice';
import setPageTitle from 'utils/setPageTitle';
import getCategoryId from '../selector/getCategoryId';
import setCurrentCategoryOperation from './setCurrentCategoryOperation';

const addLanguagePrefix = (
  langPrefix: string,
  items: AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response.ISidebarItem[],
) => {
  items.forEach((sideBarItem) => {
    if (sideBarItem.url.substring(0, langPrefix.length) !== langPrefix) {
      sideBarItem.url = `${langPrefix}${sideBarItem.url}`;
    }
    if (sideBarItem.childItems) {
      addLanguagePrefix(langPrefix, sideBarItem.childItems);
    }
  });
};

const fetchCurrentCategoryOperation =
  (updatePageTitle = false) =>
  async (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();
    const categoryId = getCategoryId(store);
    const locale = getLocaleSelector(store);
    dispatch(setCategoryLoadingAction(true));
    const categoryData = (await apiRequest(
      endpoints.categoryPageV1Get,
      {
        locale,
        categoryId,
      },
      HttpMethods.GET,
      'data',
    )) as AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response;

    const langPrefix = getLanguagePrefix(store);
    if (langPrefix) {
      addLanguagePrefix(langPrefix, categoryData.sidebarItems);
    }

    dispatch(setCurrentCategoryOperation(categoryData));
    dispatch(setCategoryLoadingAction(false));
    if (updatePageTitle) {
      setPageTitle(categoryData.title);
    }
  };

export default fetchCurrentCategoryOperation;
